import { DsButton, DsTab, DsTabs } from '@tokenyico/design-system/dist/reactJS';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const OrderDetailsTabView = ({ children, actions, onCloseModal }) => {
  const [currentTab, setCurrentTab] = useState(0);
  const { t } = useTranslation();

  return (
    <article>
      <DsTabs
        onTabChange={({ detail }) => setCurrentTab(detail)}
        currentTab={currentTab}
        version="border"
      >
        {React.Children.map(children, (child) => {
          const tabName = child.props.title ?? child.type.name;
          return (
            <DsTab activeClassName="active-tab">
              <span>{tabName}</span>
            </DsTab>
          );
        })}
      </DsTabs>
      {React.Children.map(children, (child, index) => (currentTab === index ? child : null))}
      <div style={{ flexGrow: 1 }} />
      <footer>
        <DsButton label={t('shared.close')} version="secondary" onClick={onCloseModal} />
        {actions}
      </footer>
    </article>
  );
};

// add title props to each child
OrderDetailsTabView.propTypes = {
  children: PropTypes.node,
  actions: PropTypes.node,
  onCloseModal: PropTypes.func,
};

export default OrderDetailsTabView;
